/**
 * This is a cache of issueKeys.  It is created with fixed size.
 */
export class IssueKeysCache {
	maxCacheSize: number;

	cache: string[];

	cacheSet: Set<string>;

	newKeyAdded: boolean;

	constructor(size: number) {
		this.maxCacheSize = size;
		this.cache = [];
		this.cacheSet = new Set();
		this.newKeyAdded = false;
	}

	/**
	 * Add a new issueKey into cache.  duplicated issueKey won't cause duplicated key into cache.
	 * If the maxCacheSize is reached, no new issueKey can be added.
	 * So it is caller's responsibility to pop issue from cache to make room for new issueKey.sue/common/feature-flags.js
	 * @param issueKey
	 */
	push(issueKey: string): void {
		if (this.cacheSet.size < this.maxCacheSize) {
			if (!this.cacheSet.has(issueKey)) {
				this.cacheSet.add(issueKey);
				this.newKeyAdded = true;
			}
		}
	}

	/**
	 * Remove an issueKey from cache.
	 * @param issueKey
	 */
	remove(issueKey: string): void {
		this.cacheSet.delete(issueKey);
	}

	getIssueKeysAndMarkRead(): string[] {
		this.newKeyAdded = false;
		return Array.from(this.cacheSet);
	}

	/**
	 * Has cache been updated with additional new key since last getIssueKeysAndMarkRead().
	 * As this cache can be called by anyone and any times trying to push in new keys, cache is responsible to
	 * maintain the state of hasNewKeyAdded.
	 * @returns {boolean}
	 */
	hasNewKeyAdded(): boolean {
		return this.newKeyAdded;
	}
}
